import { forwardRef } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Box, Text } from "@similarweb/ui-components/foundations";

type Props = {
    isLoading?: boolean;
};

export const EmailWidgetWrapper = forwardRef<HTMLDivElement, React.PropsWithChildren<Props>>(
    ({ children, isLoading = false }, ref) => {
        const { translate } = useTranslate();

        return (
            <>
                <Text
                    fontVariant="h5"
                    color={colorsPalettes.carbon[500]}
                >
                    {translate("si.super-agent.widgets.email.title")}
                </Text>
                <Box
                    {...(isLoading ? { height: "464px" } : { height: "fit-content" })}
                    width="692px"
                    background={colorsPalettes.carbon[0]}
                    border={`2px solid ${colorsPalettes.carbon[50]}`}
                    borderRadius="16px"
                    margin="16px 0"
                    data-automation="super-agent-email-widget"
                    ref={ref}
                >
                    {children}
                </Box>
            </>
        );
    },
);
